import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux";
import { getHandymanSettingAsync } from '../Common/api-clients/settingsClient';
import { AppState } from "../Common/Reducer/rootReducerTypes";
import { updateSetting } from '../Common/Reducer/settingsActionsAndReducer';
import { BackendTypeName } from "../Common/Utils/backendDataParser";
import useBackendData from "./useBackendData";

export default function useBackendSetting(settingKey: string) {
  const dispatch = useDispatch();
  const user = useSelector((state: AppState) => state.user);
  const settings = useSelector((state: AppState) => state.settingState.settings);
  const setting = settings.find(setting => setting.hasOwnProperty(settingKey));
  const [selectedClient] = useBackendData();

  useEffect(() => {
    if (user && !setting && selectedClient.backendName === BackendTypeName.Handyman) {
      getHandymanSettingAsync(settingKey,  selectedClient.name)
        .then(setting => {
          dispatch(updateSetting({ [settingKey]: setting }));
        });
    }
  }, []);

  return setting;
}